import { configService } from '../services'

const state = {
  configs: []
}

const getters = {
  findAll (state) {
    return state.configs
  },
  getHelpData (state) {
    return state.configs.find(config => config.name === 'helpUrl')
  }
}

const mutations = {
  getAll (state, configs) {
    state.configs = configs
    const foundAt = state.configs.findIndex(config => config.name === 'helpUrl')
    if (foundAt === -1) {
      state.configs.push({
        id: null,
        name: 'helpUrl',
        value: null
      })
    }
  },
  update (state, data) {
    state.configs = data
  }
}

const actions = {
  findAll (context) {
    return configService.findAll()
      .then(response => {
        context.commit('getAll', response.data)
        return response
      })
  },
  update (context, data) {
    return configService.update(data)
      .then(() => {
        context.commit('update', data)
        context.dispatch('alert/success', `Mise à jour réussie de la configuration.`, { root: true })
        return data
      })
      .catch(() => {
        context.dispatch('alert/error', 'Echec de la mise à jour de la configuration.', { root: true })
      })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
